// src/hooks/useModal.ts
import { useState } from "react";

export function useModal() {
  const [showModal, setShowModal] = useState<Record<string, boolean>>({});

  const toggleShowModal = (modalName: string, state: boolean) => {
    setShowModal((prev) => ({ ...prev, [modalName]: state }));
  };

  return { showModal, toggleShowModal };
}
